import React, { useState, useEffect } from "react";
import Loader from "components/Loader";
import * as moment from "moment";
import { useUserContext } from "store/contexts/userContext";
import UserDefaultAvatar from "assets/img/user.svg";
import classNames from "classnames";
import MediaPreview from "components/MediaPreview/MediaPreview";

export default ({ message }) => {
  const { user } = useUserContext();
  const [showMediaMessage, setShowMediaMessage] = useState(null);
  const [userData] = useState(
    user.id === message.state.attributes.id ? true : false
  );

  useEffect(() => {
    if (message.type === "media") {
      (async () => {
        try {
          await message?.media?.getContentTemporaryUrl().then(function (url) {
            setShowMediaMessage(url);
          });
        } catch (e) {
          console.error(e);
        }
      })();
    }
  }, [message]);

  const checkSrc = (e) => {
    e.target.src = UserDefaultAvatar;
  };

  return (
    <div
      className={classNames({
        "wc-other-user ": userData ? true : false,
        "wc-current-user": !userData ? true : false,
        "wc-user-msgs": true,
      })}
    >
      {!userData && (
        <div className="wc-img_user">
          <img
            onError={checkSrc}
            src={message?.state?.attributes?.avatar ?? UserDefaultAvatar}
            alt={"user"}
          />
        </div>
      )}
      <div className="wc-user-data">
        <span className="waterCooler_uname">
          {message?.state?.attributes?.full_name}
        </span>
        {message?.state?.body && (
          <div
            className={classNames({
              "wc-message": true,
              waterCoolerYourComment: userData ? true : false,
            })}
          >
            {message?.state?.body}
          </div>
        )}
        {message.type === "media" && (
          <>
            {showMediaMessage === null && <Loader />}
            {showMediaMessage !== null && (
              <MediaPreview attachment={showMediaMessage} type={"image"}>
                <img
                  onError={checkSrc}
                  style={{ width: "100%", maxWidth: "250px" }}
                  src={showMediaMessage}
                  alt="showMediaMessage"
                />
              </MediaPreview>
            )}
          </>
        )}
        <div className="fs-12 color-light">
          {moment(message?.state?.dateUpdated).format("LT")}
        </div>
      </div>
      {userData && (
        <div className="wc-img_user">
          <img
            onError={checkSrc}
            src={message?.state?.attributes?.avatar ?? UserDefaultAvatar}
            alt={"user"}
          />
        </div>
      )}
    </div>
  );
};
